// HFv4 Unit Review / Assessment Speaking 1–2 rubric row order.
// Display-only: do not import from shared accessors or the ProgressTests reducer.
// Import as a namespace (`import * as speakingSubSkillOrderHFv4`).

const SPEAKING_1 = 'Speaking 1';
const SPEAKING_2 = 'Speaking 2';

const BUCKET_VOCABULARY = 0;
const BUCKET_GRAMMAR_STRUCTURES = 1;
const BUCKET_CONFIDENCE_FLUENCY = 2;
const BUCKET_PRONUNCIATION = 3;
const BUCKET_OTHER = 4;
const STABLE_INDEX_SPAN = 10000;

export function isSpeaking1Or2Skill(skill) {
  const name = skill && skill.name;
  return name === SPEAKING_1 || name === SPEAKING_2;
}

function bucketForSubSkillName(name) {
  const normalized = `${name || ''}`.trim().toLowerCase();
  if (normalized === 'vocabulary') {
    return BUCKET_VOCABULARY;
  }
  if (normalized.includes('grammar') || normalized.includes('structures')) {
    return BUCKET_GRAMMAR_STRUCTURES;
  }
  if (normalized === 'confidence and fluency') {
    return BUCKET_CONFIDENCE_FLUENCY;
  }
  if (normalized === 'pronunciation') {
    return BUCKET_PRONUNCIATION;
  }
  return BUCKET_OTHER;
}

export function sortSubSkills(subSkills) {
  if (! subSkills || ! subSkills.size) {
    return subSkills;
  }
  return subSkills.sortBy((subSkill, index) =>
    (bucketForSubSkillName(subSkill.name) * STABLE_INDEX_SPAN) + index);
}

export function orderSpeakingSubSkillsIfNeeded(skill) {
  if (! skill || ! isSpeaking1Or2Skill(skill) || ! skill.subSkills) {
    return skill;
  }
  return skill.set('subSkills', sortSubSkills(skill.subSkills));
}



// WEBPACK FOOTER //
// ./data/ProgressTests/speakingSubSkillOrderHFv4.js